export const SessionTypes = {
  REGULAR: "regular",
  ANYTIME: "anytime",
  /** @deprecated */
  BLOCK: "block",
  PRIVATE: "private"
};
